// import '@theme/lenis';

import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// --- IMPORTANT FIX: REGISTER PLUGINS FIRST ---
if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

/**
 * 1. PERFORMANCE MONITORING SUITE
 * Registers observers before any other logic to ensure no data is missed.
 */

// --- Long Task Observer (TBT/Input Delay) ---
// const longTaskObserver = new PerformanceObserver((list) => {
//   list.getEntries().forEach((entry) => {
//     console.warn(`❗ Long Task: ${entry.duration.toFixed(2)}ms`);
//   });
// });

// // --- LCP Observer (Loading Speed) ---
// const lcpObserver = new PerformanceObserver((list) => {
//   const entries = list.getEntries();
//   const lastEntry = entries[entries.length - 1];
//   console.log(`🚀 LCP: ${lastEntry.startTime.toFixed(2)}ms`, lastEntry.element);
// });

// // --- CLS Observer (Visual Stability) ---
// const clsObserver = new PerformanceObserver((list) => {
//   list.getEntries().forEach((entry) => {
//     if (!entry.hadRecentInput) {
//       console.error(`❌ Layout Shift: ${entry.value.toFixed(4)}`);
//       entry.sources.forEach(s => console.log('Shifted:', s.node));
//     }
//   });
// });

// // Start them up
// try {
//   longTaskObserver.observe({ type: 'longtask' });
//   lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
//   clsObserver.observe({ type: 'layout-shift', buffered: true });
// } catch (e) {
//   console.error("Observers failed:", e);
// }

// // --- TTFB Observer (Server Response Time) ---
// const navigationObserver = new PerformanceObserver((list) => {
//   const [entry] = list.getEntries();
//   const ttfb = entry.responseStart - entry.startTime;

//   console.log(`📡 Server Response (TTFB): ${ttfb.toFixed(2)}ms`);

//   if (ttfb > 600) {
//     console.warn("⚠️ Slow Server Response: The delay is happening before the browser even gets your code.");
//   }
// });

// try {
//   navigationObserver.observe({ type: 'navigation', buffered: true });
// } catch (e) { }

/**
 * 2. OPTIMIZED LENIS INITIALIZATION
 */

const initLenis = () => {
  const lenis = new Lenis({
    lerp: 0.1,
    wheelMultiplier: 0.7,
    gestureOrientation: "vertical",
    normalizeWheel: false,
    smoothTouch: false
  });

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update);

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);

  // function raf(time) {
  //   lenis.raf(time);
  //   requestAnimationFrame(raf);
  // }
  // requestAnimationFrame(raf);

  // High-performance resize handling
  const startObservers = () => {
    const resizeObserver = new ResizeObserver(() => lenis.resize());
    resizeObserver.observe(document.body);
    window.addEventListener('load', () => lenis.resize());
    console.log('✅ Lenis Observers Active');
  };

  // if ('requestIdleCallback' in window) {
  //   window.requestIdleCallback(startObservers);
  // } else {
  //   setTimeout(startObservers, 1000);
  // }

  startObservers();
};

if (window.innerWidth >= 750) {
  initLenis();
}